import Link from 'next/link';
import { FC } from 'react';
import { IoAdd, IoCheckmark, IoCopyOutline, IoShareOutline } from 'react-icons/io5';

import { ActionIcon, Menu } from '@mantine/core';
import { CollectionHelpers } from 'src/helpers/CollectionHelpers';

import { CompanyProfile, PermissionCompany, PublishedStatus } from 'models';
import { CryptoHelpers } from 'helpers/CryptoHelpers';
import { TeamHelpers } from 'helpers/TeamHelpers';

import { useProfilePermission } from 'components/company-profile/hooks/use-profile-permission';
import { useCopyShareUrl } from 'hooks/use-copy-share-url';

import cx from './Header.module.scss';

const ShareButton: FC<{ company: CompanyProfile }> = ({ company }) => {
    const canEdit = useProfilePermission(PermissionCompany.EDIT);

    const preview = company.status !== PublishedStatus.PUBLISHED;
    const hash = CryptoHelpers.unsafeSimpleHash(company.slug);

    const { clipboard, share } = useCopyShareUrl('profile', preview ? { preview: hash } : undefined);

    return (
        <Menu trigger="click-hover" position="bottom-start" closeOnItemClick={false}>
            <Menu.Target>
                <ActionIcon variant="white" size="lg" radius={99} className={cx.circle} aria-label="Share profile">
                    <IoShareOutline size={16} />
                </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
                <Menu.Item leftSection={clipboard.copied ? <IoCheckmark /> : <IoCopyOutline />} onClick={share}>
                    {clipboard.copied ? 'Copied url' : 'Copy url'}
                </Menu.Item>
                {canEdit && (
                    <Menu.Item
                        leftSection={<IoAdd />}
                        component={Link}
                        href={TeamHelpers.urls.settings(CollectionHelpers.id(company.team))}
                    >
                        Invite team members
                    </Menu.Item>
                )}
            </Menu.Dropdown>
        </Menu>
    );
};

export { ShareButton };
